import { FC } from 'react';
import { AdvancedSearchQuestionProps } from '../../../typings/advancedSearch'
import NiceModal from "@ebay/nice-modal-react";
import { QuestionProps } from '../../../typings/register';
import { getMemberPremiumStatus } from '../../../services/memberService';
import { useHistory } from 'react-router-dom';
import usePrepareLink from '../../../hooks/usePrepareLink';
import { GET_PARAMS, GET_POPUPS } from '../../../const/router';

export type AdvancedSearchQuestionType = {
    questions: QuestionProps[];
    setQuestionAnswers: (questionId: number, questionTag: number[]) => void;
    selectedQuestionTags: any;

}

const AdvancedSearchQuestion: FC<AdvancedSearchQuestionType> = ({ selectedQuestionTags, questions, setQuestionAnswers }) => {

    let history = useHistory();
    const premiumMessagelink = usePrepareLink({
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
        },
        keepOldQuery: true,
    });

    const openQuestionSelect = async (question: QuestionProps) => {
        const { data: isPremium } = await getMemberPremiumStatus();
        if (isPremium) {
            NiceModal.show("question_modal", {
                question: question,
                onNext: setQuestionAnswers,
                primaryButtonText: "המשך",
                selectedQuestionTags: selectedQuestionTags.filter((x: any) => x.questionId === question.questionId)[0]
            });
        } else {
            history.push(premiumMessagelink);
        }

    }


    return (
        <>

            <ul className="prior_links_list w-list-unstyled">
                {
                    questions.map((question, index) => {
                        const filterQuestion = selectedQuestionTags.filter((x: any) => x.questionId === question.questionId)[0];
                        const answers = filterQuestion ? filterQuestion.questionAnswers.join(" ,") : "";
                        return <li key={question.questionId} className="prior_link_item">
                            <a onClick={() => openQuestionSelect(question)} href="#" className="prior_link w-inline-block">
                                {/* <div className="prior_icon_block">
                                    <img src="/assets/images/ic_info_smoke.svg" loading="lazy" alt="" />
                                </div> */}
                                <div className="prior_link_info w-clearfix">
                                    <h4 className="prior_link_title" style={{ textAlign: 'right' }}>{question.questionId === 15 ? 'סטטוס זוגי' : question.question}</h4>
                                    <div style={{ textAlign: 'right' }}>{answers}</div>
                                    <div className="prior_status_block w-clearfix">
                                        <div>לבחירה</div>
                                        <img
                                            src="/assets/images/prior_arrow.svg"
                                            loading="lazy"
                                            alt=""
                                            className="prior_stat_icon"
                                        />
                                    </div>
                                </div>
                            </a>
                            {
                                index < (questions.length - 1) ?
                                    <div className="prior_item_line" />
                                    :
                                    null
                            }

                        </li>
                    })
                }

            </ul>
        </>
    )

}

export default AdvancedSearchQuestion;